import { APP_INIT_DEFERRED, AUTH_ACTIVATE_ACCOUNT, AUTH_LOGIN } from '../actions';
import { fetchAvailableOrganizations } from '../actions/available-organizations.actions';
import userService from '../../services/user.service';

export const onAuthenticationProcessDone =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (
      action.type === AUTH_LOGIN ||
      action.type === APP_INIT_DEFERRED ||
      action.type === AUTH_ACTIVATE_ACCOUNT
    ) {
      if (!userService.isAuthenticated) return false;

      dispatch(fetchAvailableOrganizations());
    }
  };

export const availableOrganizationsMiddleware = [onAuthenticationProcessDone];
